// src/utils/logger.js
/**
 * Console logger utility that disables console logs in production
 * but keeps them enabled in development mode
 */

const isDevelopment = import.meta.env.MODE === 'development';
const isProduction = import.meta.env.MODE === 'production';

// Store original console methods
const originalConsole = {
  log: console.log.bind(console),
  warn: console.warn.bind(console),
  error: console.error.bind(console),
  info: console.info.bind(console),
  debug: console.debug.bind(console),
  trace: console.trace.bind(console),
  group: console.group.bind(console),
  groupCollapsed: console.groupCollapsed.bind(console),
  groupEnd: console.groupEnd.bind(console),
  table: console.table.bind(console),
  time: console.time.bind(console),
  timeEnd: console.timeEnd.bind(console),
};

/**
 * Initialize console override
 * Disables console methods in production, keeps them in development
 */
export const initConsoleOverride = () => {
  if (isProduction) {
    // Override console methods with no-op functions in production
    console.log = () => {};
    console.info = () => {};
    console.debug = () => {};
    console.trace = () => {};
    console.group = () => {};
    console.groupCollapsed = () => {};
    console.groupEnd = () => {};
    console.table = () => {};
    console.time = () => {};
    console.timeEnd = () => {};
    
    // Keep console.warn and console.error for critical issues
    // but you can disable them too if needed
    // console.warn = () => {};
    // console.error = () => {};
    
    // No log message in production - completely silent
  } else {
    // Development mode - keep all console methods as-is
    originalConsole.log('%c[Logger] Console logs enabled in development mode', 'color: #4CAF50; font-weight: bold;');
  }
};

/**
 * Get original console methods (useful for debugging)
 */
export const getOriginalConsole = () => originalConsole;

// Auto-initialize when module is imported
initConsoleOverride();
